import React, { Component } from "react";
import UserService from "../../../services/UserService";
import JobApplicationEntity from "../../../types/jobApplicationEntity.type";
import UserDetailsView from "./JobApplicationDetailView";
import JobApplicationDetailView from "./JobApplicationDetailView";
import EmptyJobApplicationsView from "../EmptyJobApplicationsView";
import JobApplicationsService from "../../../services/JobApplicationsService";


type Props = {
  jobApplicationId?: number;
};

type State = {
  content: JobApplicationEntity | any,
  user?: JobApplicationEntity | any,
  id?: number | undefined
}

export default class BoardJobApplication extends Component<Props, State> {
  constructor(props: Props) {
    super(props);


    this.state = {
      content: new Object(),
      user: new Object(),
      id: 1
    };
  }

  componentDidMount() {
    console.log("component mounted");
    if (this.state.id != null) {
      JobApplicationsService.getJobApplication(this.state.id).then(
        response => {
          this.setState({
            content: response.data
          });
        },
        error => {
          this.setState({
            content:
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString()
          });
        }
      );
    }
  }

  render() {
    let view = null;
    console.log("id: " + this.state.content?.id);
    let myEmail = this.state.user?.email;
    let viewableUser = this.state.content;
    if (viewableUser != null) {
      view = <JobApplicationDetailView userId={viewableUser.id} jobApplicationEntity={viewableUser} />;
    } else {
      view = <EmptyJobApplicationsView />;
    }

    return (
      <div className="container">
        {view}
      </div>
    );
  }
}